import React, { useState, useRef, useEffect, useCallback } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { InputMask } from "primereact/inputmask";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { FaFileDownload } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ProgressBar } from "primereact/progressbar";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import DataControls from "../../components/DataTools/DataControls";
import TransactionService from "../../services/TransactionService";
import { getLocalStorage, setLocalStorage } from "../../services/LocalStorage";

import { useLanguageContext } from "../../context/GlobalProvider";
import { showErrorToast } from "../../components/CustomToast";
import { ImportStageMessage } from "../../utils/ImportStage";

export default function UploadJounral() {
  const DefaultHotelId = getLocalStorage("defaultHotelId");
  const userHotels = getLocalStorage("userHotels") || [];
  const roles = getLocalStorage("roles") || [];
  const hasVinciRole = roles.includes("IMPORT_JOURNAL_VINCI");
  const hasForceVinciRole = roles.includes("IMPORT_FORCE_VINCI");
  const hasMadehoRole = roles.includes("IMPORT_JOURNAL_MADEHO");
  const [initialSyncValue, setInitialSyncValue] = useState(false);
  const [periodValue, setPeriodValue] = useState("");
  const [importType, setImportType] = useState("journal");
  const [selectedFecHotelId, setSelectedFecHotelId] = useState(DefaultHotelId);
  const [uploadJournalBadges, setUploadJournalBadges] = useState([]);
  const [month] = useState(getLocalStorage("month"));
  const [year] = useState(getLocalStorage("year"));
  const toast = useRef(null);

  const { t } = useLanguageContext();

  //for ProgressBar process status indicator.
  const [importStage, setImportStage] = useState("");
  let [progressValue, setProgressValue] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [showSpinnerBar, setShowSpinnerBar] = useState(false);
  const [showCancelButton, setShowCancelButton] = useState(true);
  const [importStatus, setImportStatus] = useState(false);
  const interval = useRef(null);
  const [disabledButton, setDisabledButton] = useState(false);
  const [forceImport, setForceImport] = useState(false);
  const selectMaxFileSize = 1024 * 1024 * 100;
  const importTypeOptions = [
    { label: t("journalImportType"), value: "journal" },
    { label: t("fecImportType"), value: "fec" },
  ];
  const ref = useRef();
  const onHandleClearSelectedFile = e => {
    ref.current.clear();
  };

  function handlePeriodValueChange(event) {
    setPeriodValue(event.target.value);
  }

  function formatLastClosedPeriod(year, month) {
    return year + "/" + month;
  }

  useEffect(() => {
    setUploadJournalBadges([
      {
        key: "1",
        filterValue: formatLastClosedPeriod(year, month),
        removable: false,
      },
    ]);
  }, [year, month]);

  //i
  const importJournal = useCallback(
    event => {
      setLocalStorage("periodvalue", periodValue);
      setLocalStorage("currentSelectedFile", ref.current.value);

      //disable button
      setDisabledButton(true);
      setShowSpinnerBar(true);

      setShowCancelButton(false);

      const period =
        periodValue.substring(0, 4) + "0" + periodValue.substring(5);
      if (hasMadehoRole && importType === "fec") {
        if (!selectedFecHotelId) {
          toast.current.show({
            severity: "error",
            summary: t("errorMessage"),
            detail: t("fecHotelRequired"),
            life: 5000,
          });
          setDisabledButton(false);
          setShowSpinnerBar(false);
          setShowCancelButton(true);
          return;
        }
        const formData = new FormData();
        formData.append("isInitialSync", initialSyncValue);
        formData.append("period", period);
        formData.append("file", event.files[0]);
        TransactionService.uploadFecTransactionFile(
          selectedFecHotelId,
          formData,
        )
          .then(res => {})
          .catch(error => {
            showErrorToast(toast, t, error, false);
            setForceImport(false);
            ref.current.clear();
            setDisabledButton(false);
            setShowSpinnerBar(false);
            setShowProgressBar(false);
            setShowCancelButton(true);
          });
      } else if (hasVinciRole) {
        const formData = new FormData();
        formData.append("isInitialSync", initialSyncValue);
        formData.append("period", period);
        formData.append("forceImport", forceImport);
        formData.append("file", event.files[0]);
        TransactionService.uploadVinciTransactionFile(DefaultHotelId, formData)
          .then(res => {})
          .catch(error => {
            showErrorToast(toast, t, error, false);
            setForceImport(false);
            ref.current.clear();
            setDisabledButton(false);
            setShowSpinnerBar(false);
            setShowProgressBar(false);
            setShowCancelButton(true);
          });
      } else {
        const formData = new FormData();
        formData.append("isInitialSync", initialSyncValue);
        formData.append("period", period);
        formData.append("file", event.files[0]);
        TransactionService.uploadTransactionFile(DefaultHotelId, formData)
          .then(res => {})
          .catch(error => {
            showErrorToast(toast, t, error, false);
            setForceImport(false);
            ref.current.clear();
            setDisabledButton(false);
            setShowSpinnerBar(false);
            setShowProgressBar(false);
            setShowCancelButton(true);
          });
      }

      //uploadTransactionFileProgress service
      clearInterval(interval.current);
      interval.current = setInterval(() => {
        TransactionService.uploadTransactionFileProgress(
          DefaultHotelId,
          getLocalStorage("groupHotel"),
        )
          .then(res => {
            //addded new
            setShowSpinnerBar(true);
            console.log("res.data", res.data.importStatus);
            //setImport status
            setImportStatus(res.data.importStatus);
            setProgressValue(res.data.importProgress);
            setImportStage(res.data.importStage);
            if (res.data.importStatus === true) {
              setShowProgressBar(true);

              setShowSpinnerBar(true);
            }
          })
          .catch(error => {
            clearInterval(interval.current);
            setForceImport(false);
            ref.current.clear();
            showErrorToast(toast, t, error, false);
            setDisabledButton(false);
            setShowSpinnerBar(false);
            setShowProgressBar(false);
            setShowCancelButton(true);
          });
      }, 2000);

      return () => {
        if (interval.current) {
          clearInterval(interval.current);
          interval.current = null;
        }
      };
    },
    [
      DefaultHotelId,
      t,
      periodValue,
      initialSyncValue,
      showProgressBar,
      hasVinciRole,
      forceImport,
      hasMadehoRole,
      importType,
      selectedFecHotelId,
    ],
  );

  useEffect(() => {
    clearInterval(interval.current);

    TransactionService.uploadTransactionFileProgress(
      DefaultHotelId,
      getLocalStorage("groupHotel"),
    )
      .then(res => {
        //setImport status
        setImportStatus(res.data.importStatus);
        if (res.data.importStatus === true) {
          setShowProgressBar(true);

          clearInterval(interval.current);
          interval.current = setInterval(() => {
            TransactionService.uploadTransactionFileProgress(
              DefaultHotelId,
              getLocalStorage("groupHotel"),
            )
              .then(res => {
                //setImport status
                setImportStatus(res.data.importStatus);
                if (res.data.importStatus === true) {
                  setImportStage(res.data.importStage);
                  setProgressValue(res.data.importProgress);

                  setShowProgressBar(true);
                  setShowSpinnerBar(true);
                  setDisabledButton(true);
                  setShowCancelButton(false);
                }
                if (res.data.importStatus === false) {
                  toast.current.show({
                    severity: "info",
                    summary: "Success",
                    detail: ImportStageMessage(res.data.importStage, t),
                    life: "60000",
                  });
                  setProgressValue(0);
                  setPeriodValue("");
                  setForceImport(false);
                  ref.current.clear();

                  setDisabledButton(false);
                  //hide spinner bar
                  setShowSpinnerBar(false);
                  setShowProgressBar(false);
                  //show cancelbutton
                  setShowCancelButton(true);
                  clearInterval(interval.current);
                }
              })
              .catch(error => {
                clearInterval(interval.current);
                setForceImport(false);
                ref.current.clear();
                setDisabledButton(false);
                setShowSpinnerBar(false);
                setShowProgressBar(false);
                setShowCancelButton(true);
                showErrorToast(toast, t, error, false);
              });
          }, 3000);
        } else if (res.data.importStatus === false) {
          setForceImport(false);
          ref.current.clear();
          setShowProgressBar(false);
          //new added maybe we deleted

          clearInterval(interval.current);
        }
      })
      .catch(error => {
        //catch error
        clearInterval(interval.current);
        setForceImport(false);
        ref.current.clear();
        setDisabledButton(false);
        setShowSpinnerBar(false);
        setShowProgressBar(false);
        setShowCancelButton(true);
        showErrorToast(toast, t, error, false);
      });
    return () => {
      if (interval.current) {
        clearInterval(interval.current);
        interval.current = null;
      }
    };
  }, [DefaultHotelId, showProgressBar, t]);

  useEffect(() => {
    if (importStatus === true) {
      setShowProgressBar(true);
    }
  }, [importStatus]);

  return (
    <React.Fragment>
      <DataControls
        displayedImportExportDataControl="false"
        filters={uploadJournalBadges}
      />
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className="surface-card p-8 shadow-2 border-round">
        {!hasVinciRole && (
          <div className="field mb-4 col-6">
            <FaFileDownload style={{ color: "blue" }} />

            <Link
              to="../../../assets/files/Jounal Template.csv"
              target="_blank"
              download
            >
              {t("titleJournalTemplateDownloadLink")}
            </Link>
          </div>
        )}
        <div className="mb-3 flex align-items-center justify-content-between">
          {getLocalStorage("roles")?.includes("INIT_SYNC") && (
            <div className=" grid field mb-4 col-6">
              <div>
                <label>{t("labelInitialSyncField")}</label>
              </div>

              <div>
                <InputSwitch
                  id="initialSync"
                  style={{ marginLeft: "12px" }}
                  checked={initialSyncValue}
                  onChange={e => setInitialSyncValue(e.value)}
                  disabled={disabledButton}
                ></InputSwitch>
              </div>
            </div>
          )}
        </div>

        <div className="field mb-4 col-6">
          <InputMask
            mask="9999/99"
            placeholder={t("placeholderPeriodField")}
            id="period"
            value={periodValue}
            onChange={handlePeriodValueChange}
            disabled={disabledButton}
          />
        </div>

        {hasVinciRole && hasForceVinciRole && (
          <div className="field mb-4 col-6">
            <Checkbox
              inputId="forceImport"
              checked={forceImport}
              onChange={event => {
                if (!event.checked) {
                  setForceImport(false);
                  return;
                }

                setForceImport(true);
                confirmDialog({
                  message: (
                    <span>
                      <strong>Attention :</strong>{" "}
                      {t("forceImportWarningMessage")}
                    </span>
                  ),
                  header: t("forceImportConfirmationTitle"),
                  icon: "pi pi-exclamation-triangle",
                  acceptClassName: "p-button-danger",
                  acceptLabel: t("acceptLabelConfirmDialog"),
                  rejectLabel: t("rejectLabelConfirmDialog"),
                  reject: () => setForceImport(false),
                });
              }}
              disabled={disabledButton}
            />
            <label htmlFor="forceImport" className="ml-2">
              {t("forceImportLabel")}
            </label>
          </div>
        )}

        {hasMadehoRole && (
          <React.Fragment>
            <div className="field mb-4 col-6">
              <Dropdown
                value={importType}
                options={importTypeOptions}
                onChange={e => setImportType(e.value)}
                disabled={disabledButton}
                placeholder={t("importTypePlaceholder")}
                className="w-full"
              />
            </div>

            {importType === "fec" && (
              <div className="field mb-4 col-6">
                <Dropdown
                  value={selectedFecHotelId}
                  options={userHotels}
                  onChange={e => setSelectedFecHotelId(e.value)}
                  optionLabel="name"
                  optionValue="hotelId"
                  filter
                  filterBy="name"
                  placeholder={t("fecHotelPlaceholder")}
                  disabled={disabledButton}
                  className="w-full"
                />
              </div>
            )}
          </React.Fragment>
        )}

        <div className="field mb-4 col-6">
          <div className="import-action-container">
            <div className="upload-file-container">
              <FileUpload
                mode="basic"
                name="file"
                accept={
                  hasMadehoRole && importType === "fec"
                    ? ".txt,.csv"
                    : ".csv,.xlsx,.xls"
                }
                maxFileSize={selectMaxFileSize}
                customUpload={true}
                chooseLabel={t("fileUploadButton")}
                uploadHandler={importJournal}
                ref={ref}
                disabled={disabledButton}
              />
            </div>
            <div className="cancel-button-container">
              {showCancelButton ? (
                <Button
                  label={t("cancelButton")}
                  onClick={() => {
                    onHandleClearSelectedFile();
                  }}
                  className="p-button-secondary  p-button-outlined  w-auto mr-2 ml-2"
                />
              ) : null}
            </div>

            <div className="spinner-bar-container">
              {showSpinnerBar && (
                <span className="flex" style={{ color: "#64748b" }}>
                  <i
                    className="flex align-items-center justify-content-center pi pi-spin pi-spinner"
                    style={{ fontSize: "2em" }}
                  ></i>
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="field mb-2 col-6">
          {showProgressBar && (
            <React.Fragment>
              <span className="font-bold text-xl ">
                {ImportStageMessage(importStage, t)}
              </span>
              <ProgressBar value={progressValue} className="mt-3" />
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
